import React, { Component } from 'react';
// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

//Componentes Atentus
import FastView from './components/FastView'
import Fade from "@material-ui/core/Fade";
import PerfectScrollbar from "react-perfect-scrollbar";
import UserNotification from './components/UserNotification';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// Component styles
const styles = theme => ({
    root: {
        "& .MuiPaper-root": {
            borderColor: '#fff'
        },
        backgroundColor: '#fff',
        height: '100%',
    },
    item: {
        height: '100%'
    },
    rootError: {
        paddingTop: theme.spacing(3),
        flexGrow: 1,
      },
    paper: {
        padding: theme.spacing(2),
        margin: 'auto',
        maxWidth: 500,
      },
    text: {
        color:'#FF7E00', 
        borderBottom:'1px solid #FF7E00'
    },
    subText: {
        color: theme.palette.text.secondary
    },
    bWhite:{
        backgroundColor:"white",
        //width: '100%',
    },
});

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            objectivesList: {},
            objExist: false
        }
    }
    myCallback = (dataFromChild) => {
        /*var obje = {
            "NoMonitoringPartial": [],
            "Uptime": [],
            "Partial": [],
            "NoMonitoring": [],
            "Downtime": [],
            "Services": [],
            "ServicesUnified": []}*/
        this.setState({
            objectivesList: dataFromChild,
            objExist: this.validarEstructura(dataFromChild)
        })
    }
    
    validarEstructura = (obj) => {
        const camposRequeridos = ["NoMonitoringPartial", "Uptime", "Partial", "NoMonitoring", "Downtime"];
        // 1. Verificar si es un objeto y no es null
        // 1. Verificación básica de objeto
        if (typeof obj !== 'object' || obj === null) return false;

        // 2. .some() devuelve true si al menos un elemento cumple la condición
        return camposRequeridos.some(campo => 
            Array.isArray(obj[campo]) && obj[campo].length > 0
        );
    }

    render() {
        const { classes } = this.props;
        const { objectivesList, objExist } = this.state
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        return (
            <div>
                {Object.keys(objectivesList).length > 0 && !objExist ? 
                    <DashboardLayout title={t('dashboard-layout.title.quickview')} callbackFromParent={this.myCallback} isFirstTime={true}>
                        <div className={classes.rootError}>
                            <Paper className={classes.paper}>
                                <Grid
                                    container
                                    //spacing={4}
                                    justify="center"
                                    alignItems="center">
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        xl={12}>
                                            <Typography variant="h1" className={classes.text}>Se ha producido un error</Typography>
                                        <Typography variant="h6" className={classes.subText}>Al parecer no se encuentran objetivos activos.</Typography>
                                        <Typography variant="h6" className={classes.subText}>Espere un momento, y recargue la página.</Typography>
                                        <Typography variant="h6" className={classes.subText}>Si el error persiste, por favor póngase en contacto con su ejecutivo comercial.</Typography>
                                        <Typography variant="h6" className={classes.subText}>Muchas gracias.</Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </div>
                    </DashboardLayout>
                : 
                    <div>
                        <UserNotification />
                        <DashboardLayout title={t('dashboard-layout.title.quickview')} callbackFromParent={this.myCallback} isFirstTime={true}>
                            <div className={classes.root}>
                                <FastView params={objectivesList} />
                            </div>
                        </DashboardLayout>
                    </div>
                }
            </div>
        );
    }
}
Dashboard.propTypes = {
    classes: PropTypes.object.isRequired
};
export default compose(withStyles(styles), withTranslation())(Dashboard);